import React from 'react';
import DocumentIdProcessVerification from '../common/DocumentIdProcessVerification';

const OwnershipDocVerification = () => {
  return <DocumentIdProcessVerification isEntity={true} isMultiple={true} />;
};

export default OwnershipDocVerification;
